import { useEffect, useMemo, useState } from 'react';
import {
  CheckoutModel,
  QuarterOverviewModel,
} from 'src/core/model/quarter-overview.model';
import { sum } from 'radash';
import { QuarterOverviewStateEnum } from 'src/core/model/enum/quarter-overview-state.enum';
import { CheckoutSectionProps } from './checkout-section';
import { isIgnoredByBreakdownType } from '../quarter-overview.utils';

type Props = {
  readonly rawCheckoutList?: CheckoutModel[];
  readonly iTransactionId?: string;
  readonly onChange: (data: Partial<QuarterOverviewModel>) => void;
};

type UseEnhanceWithCheckout = CheckoutSectionProps & {
  state: QuarterOverviewStateEnum;
};

export function useEnhanceWithCheckout(props: Props): UseEnhanceWithCheckout {
  const { rawCheckoutList = [], iTransactionId, onChange } = props;

  const [list, setList] = useState<CheckoutModel[]>([]);

  const [state, setState] = useState<QuarterOverviewStateEnum>(
    QuarterOverviewStateEnum.INIT,
  );

  useEffect(() => {
    if (
      rawCheckoutList.length === 0 ||
      !iTransactionId ||
      state === QuarterOverviewStateEnum.SUCCESS
    ) {
      return;
    }

    const nextList = rawCheckoutList
      .filter((item) => !isIgnoredByBreakdownType(item))
      .filter((item) => item.iTransactionId === iTransactionId);

    if (nextList.length === 0) {
      setState(QuarterOverviewStateEnum.NO_ITEM_FOUND);
      return;
    }

    setList(nextList);

    const checkoutFees = sum(nextList, (item) => item.totalHT ?? 0);

    setState(QuarterOverviewStateEnum.SUCCESS);

    onChange({ checkoutFees });
  }, [rawCheckoutList, iTransactionId, onChange, state]);

  return useMemo(
    () => ({
      list,
      state,
    }),
    [list, state],
  );
}
